import { Account } from 'model/IChat';
import { getSortedHosts } from 'modules/experience/utils/sortHosts';
import { useLocation } from 'react-router-dom';
import { useI18n } from '~/stores/i18n';

export interface SortableIAccount extends Account {
  // Set during sorting, required for stable random ordering
  sortValue: number;
  // Optional metadata added during sorting/grouping
  firstAvailableDate?: string;
  firstAvailableTime?: string;
}

export type GetSortedHostsType = {
  experienceId: string;
  hosts: Account[] | SortableIAccount[];
  date?: string;
  time?: string;
  availableTimes?: any;
  availableDates?: { [key: string]: string[] };
  language?: string;
  highlightedHost?: string;
  sortByAvailability?: boolean;
};

type SortedHostProviderProps = GetSortedHostsType & {
  children: (args: { sortedHosts: SortableIAccount[] }) => any;
};

function SortedHostProvider(props: SortedHostProviderProps) {
  const location = useLocation();
  const { lang } = useI18n();
  const searchParams = new URLSearchParams(location.search);
  const forceHostId = searchParams.get('hostId');
  const preferredLanguage = searchParams.get('preferredLanguage');
  return props.children({
    sortedHosts: getSortedHosts({
      ...props,
      language: preferredLanguage || props.language || lang,
      highlightedHost: !!props.highlightedHost
        ? props.highlightedHost
        : forceHostId,
    }),
  });
}

export default SortedHostProvider;
